export default __webpack_public_path__ + "static/thumbnail_utopicus-4ca390dd2b915fda492efcb0a05cd240.jpg";